import { AuditLogService } from '@/modules/shared/services/audit-log.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
const auditLogService = new AuditLogService();
export const state = {
  auditLogs: []
};
export const mutations = {
  ...make.mutations(state)
};
export const actions = {
  // Get all logs based on params
  FindAll: async (_, params) => {
    try {
      const { data } = await auditLogService.findAll(params);
      return data;
    } catch (error) {
      Logger.error('getting audit logs', error);
      throw error;
    }
  },
  // Export logs based on params
  ExportLogs: async (_, params) => {
    try {
      const { data } = await auditLogService.exportLogs(params);

      // Decode base64 data
      const base64String = data;
      const byteArray = new Uint8Array(
        atob(base64String)
          .split('')
          .map((char) => char.charCodeAt(0))
      );
      const csvContent = new TextDecoder('utf-8').decode(byteArray);

      // Create Blob from decoded content
      const blob = new Blob([csvContent], {
        type:
          params.type === 'csv' ? 'application/octet-stream' : 'application/pdf'
      });

      // Create URL and download link
      const url = window.URL.createObjectURL(blob);
      const nameFile =
        params.type === 'csv' ? 'audit-log-report.csv' : 'audit-log-report.pdf';

      const link = document.createElement('a');
      link.href = url;
      link.download = nameFile;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return data;
    } catch (error) {
      Logger.error('exporting audit logs', error);
      throw error;
    }
  }
};
export const getters = make.getters(state);
